import React from "react";
import { useDurationInputSelect } from "./duration-input-select.controller";
import { ICONS } from "@frontend/icons";

export interface DurationInputSelectProps {
    className?: string;
    value?: string;
    selectItems: string[];
    onChange?: (value: string | undefined) => void;
}

export const DurationInputSelect = (props: DurationInputSelectProps) => {
    const viewProps = useDurationInputSelect(props);
    return (
        <div onClick={(e) => {e.stopPropagation()}} data-show-action-button="false" data-show-placeholder="true" data-size="Small" data-state="Open" data-type="Select" className="self-stretch flex flex-col justify-start items-start gap-1">
            <div className="w-full h-10 px-4 bg-background-surface rounded-xl outline outline-1 outline-offset-[-1px] outline-border-default inline-flex items-center overflow-hidden cursor-pointer">
                <div className="flex w-full h-full items-center gap-2.5" onClick={() => {viewProps.changeShow(!viewProps.show)}}>
                    <button className="justify-start text-foreground-default text-sm font-medium">{viewProps.value? viewProps.value : "Select..."}</button>
                </div>
                <div className="flex justify-start items-center gap-2">
                {viewProps.value !== undefined && (
                    <ICONS.BUTTON.CLOSE
                        className='text-brand-muted hover:cursor-pointer hover:text-foreground-default'
                        onClick={viewProps.clear}
                    />
                )}
                {viewProps.show 
                ? (
                    <ICONS.BUTTON.CHEVRON_UP
                        className={`text-brand-muted hover:cursor-pointer hover:text-foreground-default`}
                        id="group-select-category"
                        onClick={() => {viewProps.changeShow(!viewProps.show)}}
                    />
                ) 
                : (
                    <ICONS.BUTTON.CHEVRON_DOWN
                        className={`text-brand-muted hover:cursor-pointer hover:text-foreground-default`}
                        id="group-select-category"
                        onClick={() => {viewProps.changeShow(!viewProps.show)}}
                    />
                )}
                </div>
            </div>
            {viewProps.show && (
                <div className="dropdown-content self-stretch bg-background-surface rounded-xl outline outline-1 outline-offset-[-1px] outline-border-default flex flex-col justify-start items-start gap-4 overflow-hidden">
                    <div className="self-stretch p-2 flex flex-col justify-start items-start gap-4">
                        <div className="self-stretch flex flex-col justify-start items-start">
                            {props.selectItems.map((value) => {
                              return (
                                <div 
                                    key={value}
                                    className="dropdown-item self-stretch p-2 hover:bg-background-default rounded-lg inline-flex justify-start items-center gap-2.5 cursor-pointer"
                                    onClick={() => viewProps.onChange(value)}>
                                    <div className="justify-start text-foreground-default text-sm font-medium">{value}</div>
                                </div>
                              );  
                            })}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
